<script>
import GenericCrud from "@forms/GenericCrud.vue";
import EquipeConsultor from "@forms/EquipeConsultor.vue";
import api from "@services/api";
import _ from "lodash";

export default {
  extends: GenericCrud,
  components: { EquipeConsultor },
  props: {
    table: {
      type: String,
      default: "Equipe"
    }
  },
  data: () => ({
    consultoresDisponiveisList: [],
    consultorList: undefined,
    projetoList: undefined,
    showModalConsultor: false,
    indexEquipeConsultor: null,
    consultor: {}
  }),
  created() {
    this.getConsultorList();
  },
  methods: {
    get(id) {
      api.get(`crud/${this.table}/${id}`).then(response => {
        this.item = response.data["data"];
      });
    },
    getConsultorList() {
      api.get(`crud/Consultor/Consultores`).then(response => {
        this.consultorList = response.data["data"];
      });
    },
    openModalEquipeConsultor() {
      this.$helper.openModal();
      this.consultoresDisponiveisList = this.ListConsultoresDisponiveis();
      this.showModalConsultor = true;
    },
    removeEquipeConsultor(index) {
      this.item.consultores.splice(index, 1);
    },
    saveModalEquipeConsultor() {
      if (!this.item.consultores) {
        this.item.consultores = [];
      }
      var index =
        this.indexEquipeConsultor != null
          ? this.indexEquipeConsultor
          : this.item.consultores.length;
      if (this.consultor) {
        this.item.consultores[index] = _.clone(
          this.consultorList.filter(p => p.id == this.consultor.id)[0]
        );
      }
      this.closeModalEquipeConsultor();
    },
    closeModalEquipeConsultor() {
      this.$helper.closeModal();
      this.showModalConsultor = false;
      this.consultor = {};
      this.consultoresDisponiveisList = [];
      this.indexEquipeConsultor = null;
    },
    ListConsultoresDisponiveis() {
      return this.item.consultores === undefined
        ? this.consultorList
        : this.consultorList
        ? _.differenceWith(
            this.consultorList.map(c => ({ id: c.id, nome: c.nome })),
            this.item.consultores.map(c => ({ id: c.id, nome: c.nome })),
            _.isEqual
          )
        : [];
    }
  }
};
</script>

<template>
  <div>
    <b-form @submit.prevent="save">
      <div class="row">
        <b-form-group
          id="input-group-1"
          label="Denominação"
          label-for="denominacao"
          class="col-md-12"
        >
          <b-form-input
            id="denominacao"
            v-model="item.denominacao"
            type="text"
            :disabled="!this.editForm"
            required
          ></b-form-input>
        </b-form-group>
      </div>

      <b-button
        class="btn btn-icon mb-2 float-right"
        v-on:click="openModalEquipeConsultor()"
        :disabled="!editForm"
        variant="primary"
        >Adicionar novo consultor</b-button
      >

      <b-form-group
        id="input-group-1"
        label="Membro(s) da equipe"
        label-for="consultor"
      >
        <table class="table b-table table table-hover">
          <thead class="thead-primary">
            <tr>
              <th class="columnheader" scope="col">
                Consultor
              </th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(consultor, index) in item.consultores"
              :key="consultor.id"
            >
              <th scope="row">
                {{ consultor.nome }}
              </th>
              <td>
                <div class="float-right">
                  <b-button
                    variant="danger"
                    class="btn btn-icon ml-2"
                    v-on:click="removeEquipeConsultor(index)"
                    :disabled="!editForm"
                  >
                    <i class="fe-delete" />
                  </b-button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </b-form-group>
      <b-form-group id="button-group" class="mt-4" v-show="this.editForm">
        <b-button variant="light" class="btn" v-on:click="back()"
          >Cancelar</b-button
        >
        <b-button type="submit" variant="primary" class="btn ml-2"
          >Salvar</b-button
        >
      </b-form-group>

      <b-form-group id="button-group" class="mt-4" v-show="!this.editForm">
        <b-button variant="light" class="btn" v-on:click="back()"
          >Voltar</b-button
        >
        <b-button variant="primary" class="btn ml-2" v-on:click="edit()"
          >Editar</b-button
        >
        <b-button variant="danger" class="btn ml-2" v-on:click="remove()"
          >Remover</b-button
        >
      </b-form-group>
    </b-form>

    <b-modal
      v-model="showModalConsultor"
      title="Adicionar consultor"
      centered
      hide-footer
      @close="closeModalEquipeConsultor"
    >
      <EquipeConsultor
        :editable="true"
        :item="consultor"
        :itemDisponiveis="consultoresDisponiveisList"
        :saveModalEquipeConsultor="saveModalEquipeConsultor"
        :closeModalEquipeConsultor="closeModalEquipeConsultor"
      />
    </b-modal>

    <b-modal
      v-model="showModalDelete"
      title="Deseja realmente excluir?"
      centered
      hide-footer
      @hidden="cancelRemove()"
    >
      <div class="button-list float-right">
        <b-button
          class="btn btn btn-icon"
          variant="primary"
          v-on:click="confirmRemove()"
          >Sim</b-button
        >
        <b-button
          class="btn btn btn-icon"
          variant="light"
          @click="showModalDelete = false"
          >Não</b-button
        >
      </div>
    </b-modal>
  </div>
</template>
